/* @flow */
import * as menuHabituesActions from './actions';
import {fromJS, Record, List} from 'immutable';

const State = Record({
    savedPage: 0,
    page: 0,
    limit: 63,
    max: 0,
    habitues: List()
});

const SAVED_PAGE = 'savedPage';
const PAGE = 'page';
const MAX = 'max';
const HABITUES = 'habitues';

const menuHabituesReducer = (state = new State(), action) => {

    switch (action.type) {


        case menuHabituesActions.BACK_TO_MENU_HABITUES: {
            return state.set(PAGE, state.get(SAVED_PAGE));
        }

        case menuHabituesActions.FETCH_MENU_HABITUES_ERROR:
        case menuHabituesActions.CLEAR_MENU_HABITUES: {
            return state
                .set(HABITUES, null)
                .set(PAGE, 0)
                .set(HABITUES, List())
                .set(MAX, 0);
        }

        case menuHabituesActions.FETCH_MENU_HABITUES_SUCCESS: {
            const {page, habitues, max} = action.payload.data;
            return state
                .set(PAGE, page)
                .set(SAVED_PAGE, page)
                .set(HABITUES, fromJS(habitues))
                .set(MAX, max);
        }

    }

    return state;
};

export default menuHabituesReducer;



// WEBPACK FOOTER //
// ./src/common/menu/credit/habitues/reducer.js